var _defs, _g, _polygon, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDireo2023LogoDireo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 841.89 283.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#Gradiente_sem_nome_8);\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4 {\n        fill-rule: evenodd;\n      }\n\n      .cls-5 {\n        fill: #005faa;\n      }\n\n      .cls-2 {\n        fill: url(#Gradiente_sem_nome_36);\n      }\n\n      .cls-3 {\n        fill: url(#Gradiente_sem_nome_36-3);\n      }\n\n      .cls-4 {\n        fill: url(#Gradiente_sem_nome_36-2);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_8",
    "data-name": "Gradiente sem nome 8",
    x1: 244.07,
    y1: 52.11,
    x2: 141.52,
    y2: 244.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f08323"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e7431e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_36",
    "data-name": "Gradiente sem nome 36",
    x1: 121.44,
    y1: 30.77,
    x2: 50.16,
    y2: 164.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#307bbf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005095"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_36-2",
    "data-name": "Gradiente sem nome 36",
    x1: 172.83,
    y1: 48.76,
    x2: 74.12,
    y2: 234.14,
    xlinkHref: "#Gradiente_sem_nome_36"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_36-3",
    "data-name": "Gradiente sem nome 36",
    x1: 66.59,
    y1: 71.78,
    x2: 59.05,
    y2: 85.95,
    xlinkHref: "#Gradiente_sem_nome_36"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m356.96,196.77c0-7.14,5.33-12.02,12.02-12.02,4.88,0,7.77,2.44,9.51,5.23l-3.48,1.78c-1.11-1.92-3.34-3.38-6.03-3.38-4.42,0-7.84,3.52-7.84,8.4s3.41,8.39,7.84,8.39c2.68,0,4.91-1.43,6.03-3.38l3.48,1.78c-1.78,2.79-4.63,5.23-9.51,5.23-6.69,0-12.02-4.88-12.02-12.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m409.55,184.75c6.97,0,11.88,5.09,11.88,12.02s-4.91,12.02-11.88,12.02-11.88-5.09-11.88-12.02,4.91-12.02,11.88-12.02Zm0,3.62c-4.7,0-7.7,3.59-7.7,8.4s3,8.39,7.7,8.39,7.7-3.62,7.7-8.39-3.03-8.4-7.7-8.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m458.99,208.37l-12.12-16.93v16.93h-4.08v-23.24h4.18l11.88,16.48v-16.48h4.07v23.24h-3.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m484.25,196.77c0-7.14,5.33-12.02,12.02-12.02,4.88,0,7.77,2.44,9.51,5.23l-3.48,1.78c-1.11-1.92-3.34-3.38-6.03-3.38-4.42,0-7.84,3.52-7.84,8.4s3.41,8.39,7.84,8.39c2.68,0,4.91-1.43,6.03-3.38l3.48,1.78c-1.78,2.79-4.63,5.23-9.51,5.23-6.69,0-12.02-4.88-12.02-12.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m526.22,185.13h4.11v13.94c0,3.69,2.06,6.1,5.96,6.1s5.92-2.4,5.92-6.1v-13.94h4.11v14.04c0,5.78-3.31,9.62-10.03,9.62s-10.07-3.87-10.07-9.58v-14.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m582.07,208.37l-5.16-8.67h-4.04v8.67h-4.08v-23.24h10.21c4.6,0,7.59,3,7.59,7.28s-2.72,6.37-5.5,6.83l5.68,9.13h-4.71Zm-3.62-19.65h-5.57v7.39h5.57c2.3,0,3.97-1.46,3.97-3.69s-1.67-3.69-3.97-3.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m608.64,201.96c1.61,1.71,4.11,3.2,7.35,3.2s4.67-1.64,4.67-3.17c0-2.09-2.48-2.72-5.3-3.45-3.8-.94-8.26-2.06-8.26-6.97,0-3.83,3.38-6.79,8.47-6.79,3.62,0,6.55,1.15,8.71,3.24l-2.33,3.03c-1.81-1.81-4.29-2.65-6.72-2.65s-3.94,1.15-3.94,2.89,2.37,2.4,5.12,3.1c3.83.98,8.39,2.16,8.39,7.21,0,3.87-2.72,7.18-8.99,7.18-4.29,0-7.39-1.5-9.44-3.69l2.26-3.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m656.54,184.75c6.97,0,11.88,5.09,11.88,12.02s-4.91,12.02-11.88,12.02-11.88-5.09-11.88-12.02,4.91-12.02,11.88-12.02Zm0,3.62c-4.7,0-7.7,3.59-7.7,8.4s3,8.39,7.7,8.39,7.7-3.62,7.7-8.39-3.03-8.4-7.7-8.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m690.21,201.96c1.61,1.71,4.11,3.2,7.35,3.2s4.67-1.64,4.67-3.17c0-2.09-2.48-2.72-5.3-3.45-3.8-.94-8.26-2.06-8.26-6.97,0-3.83,3.38-6.79,8.47-6.79,3.62,0,6.55,1.15,8.71,3.24l-2.33,3.03c-1.81-1.81-4.29-2.65-6.72-2.65s-3.94,1.15-3.94,2.89,2.37,2.4,5.12,3.1c3.83.98,8.39,2.16,8.39,7.21,0,3.87-2.72,7.18-8.99,7.18-4.29,0-7.39-1.5-9.44-3.69l2.26-3.13Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m295.37,76h-31.48v79.83h31.48c25.01,0,42.37-15.8,42.37-39.86s-17.35-39.97-42.37-39.97Zm0,64.87h-14.48v-41.91c-2.4-4.09-5.19-7.32-8.25-8h20.77l3.66.07c15.28.73,23.32,11.32,23.32,24.94s-9.22,24.9-25.01,24.9Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 354.93,
    y: 76,
    width: 16.99,
    height: 79.83
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m457.19,101.73c0-14.84-10.17-25.73-26.81-25.73h-37.34v79.83h16.99v-28.61h12.45l15.68,28.61h19.51l-17.95-30.4c8.62-2.04,17.47-9.58,17.47-23.7Zm-29.33,10.89h-17.83v-22.02h17.83c6.82,0,11.97,4.31,11.97,11.01s-5.15,11.01-11.97,11.01Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "475.04 155.83 531.53 155.83 531.53 141.11 492.04 141.11 492.04 122.55 530.69 122.55 530.69 107.95 492.04 107.95 492.04 90.6 531.53 90.6 531.53 76 475.04 76 475.04 155.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m587.73,89.76c8.86,0,16.04,5.15,19.39,11.61l14.6-7.18c-5.63-9.93-15.8-19.51-33.99-19.51-23.34,0-41.89,16.75-41.89,41.29s18.55,41.29,41.89,41.29c18.19,0,28.25-9.7,33.99-19.63l-14.6-7.06c-3.35,6.58-10.53,11.61-19.39,11.61-13.89,0-24.42-11.13-24.42-26.21s10.53-26.21,24.42-26.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m659,76l-30.88,79.83h18.67l5.03-13.76h35.67l5.03,13.76h18.55l-30.76-79.83h-21.31Zm-2.63,51.35l13.29-36.62,13.17,36.62h-26.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m757.68,74.68c-24.06,0-41.65,17.23-41.65,41.29s17.6,41.29,41.65,41.29,41.77-17.24,41.77-41.29-17.59-41.29-41.77-41.29Zm0,67.5c-14.72,0-24.18-11.37-24.18-26.21s9.45-26.21,24.18-26.21,24.3,11.25,24.3,26.21-9.58,26.21-24.3,26.21Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "580.11 155.83 575.01 164.41 585.79 164.41 595.06 153.87 580.11 155.83"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "661.49 60.23 658.7 69.27 681.86 69.27 684.64 60.23 661.49 60.23"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m180.93,48.12c.2,1.41,3.72,9.35,4.56,11.54,9.84,25.91,12.75,54.87,8.8,81.99-4.65,31.93-17.96,63.57-46.82,93.63,2.01.58,28.69.26,33.08.26,10.06,0,21.57-.94,33.32-10.92,11.14-9.47,15.96-22.82,15.98-33.06v-66.25c.02-11.13-.28-22.2,0-33.27.45-17.26-13.01-36.41-32.32-42.13-4.72-1.4-13.06-2.58-16.6-1.78"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m154.05,48.13c-2.18-.53-56.71-.2-60.5-.2-9.32,0-18.95-.05-30.31,7.34-.83.54-1.63,1.1-2.41,1.68,4.7.44,8.99,1.32,11.08,2.79,3.51,2.47,5.25,4.67,5.83,7.2.65,2.83,5.54,1.91,9.6,3.08,34.96,10.08,23.28,48.2,21.17,42.22-4.9-13.86-24.99-2.1-30.95-.71-12.25,2.85-28.54,12.52-35.06,14.97l-.06,34.01c7.54-.02,9.39-.4,16.64-3.12,30.22-11.32,76.11-42.97,94.97-109.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m171.45,48.02l-8.95-.04c.13,51.02-30.22,137.67-96.39,154.68-7.79,2-13.19,2.19-21.07,2.45,3.63,9.75,10.74,18.47,19.63,23.91,12.19,7.45,24.62,6.15,36.25-1.38,49.32-34.97,74.74-89.19,74.26-148.96.16-3.77-1.73-27.25-3.73-30.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m60.77,83.82c.15,5.02,6.43,0,8.99-1.38,5.55-2.96,4.29-3.05,3.12-6.14-2.81-7.39-19.99,1.43-22.68,4.93.22-.28,2.46-.98,2.88-.97,3.7.04,7.52-1.85,7.69,3.55Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDireo2023LogoDireo);
export default __webpack_public_path__ + "static/media/Direção_2023_Logo_Direção.0b767f50d68b0b20ab91c6c314184412.svg";
export { ForwardRef as ReactComponent };